import {
  getTrackerId,
  POSTHOG_CAPTURE_ATTRIBUTES,
  TRACKER_IDS,
} from '../config/tracker';
import IconCircled from '../global/IconCircled';
import { ICON_CIRCLE_SIZE } from '../global/IconCircled/IconCircled';
import RecycleSVG from '../global/SvgComponents/Recycle_svg';
import UPSSvg from '../images/UPS-icon.svg';
import TrashieLogo from '../images/trashie-logo.svg';
import TCCoinSvg from '../global/SvgComponents/TCCoin_svg';
import GiftCardSvg from '../images/giftcard-icon.svg';
import TbbPink from '../images/tbb-pink-front.png';
import TcIcon from '../images/trashie-cash-v3.svg';
import { MINIMUM_TC_ICON_SIZE } from '../config/icons';

export const getNextButtonStyles = (storeConfig) => {
  const {
    isTrashie,
    registerTbbFlow,
  } = storeConfig;

  if (isTrashie) {
    return {};
  }

  return {
    background: registerTbbFlow?.nextButton?.bgColor,
    color: registerTbbFlow?.nextButton?.textColor,
    border: registerTbbFlow?.nextButton?.bgColor,
  };
};

export const getOptionButtonStyles = (storeConfig, border = false) => {
  const {
    isTrashie,
    registerTbbFlow,
  } = storeConfig;

  if (isTrashie) {
    return {};
  }

  return {
    color: registerTbbFlow?.nextButton?.bgColor,
    ...(border && { borderColor: registerTbbFlow?.nextButton?.bgColor }),
  };
};

export const REDEMPTION_CODE_STATUS_IDS = {
  CLAIMED: 1,
  RETURNED: 2,
  PENDING: 3,
  BLOCKED: 4,
};

export const getCouponStyle = (storeConfig) => {
  const {
    isTrashie,
    registerTbbFlow,
  } = storeConfig;

  if (isTrashie) {
    return {};
  }

  return {
    color: registerTbbFlow.rewardStep?.cardTextColor,
    background: registerTbbFlow.rewardStep?.cardBgColor,
    border: 'none',
  };
};

export const getHeaderLogo = (storeConfig) => (
  storeConfig?.registerTbbFlow?.headerLogoUrl || storeConfig?.mainLogoSrc || TrashieLogo);

export const RECYCLING_PRODUCT_TYPES = {
  TEXTIL: 'TEXTILES_TBB',
  TECH: 'TECH_BOX',
  VIRTUAL: 'VIRTUAL_BOX',
};

export const RECYCLING_PRODUCT_ITEMS = [
  { label: 'Amazon Alexa, Google Assistant' },
  { label: 'Cable box, Roku box, Apple TV' },
  { label: 'Cables, power cords, chargers' },
  { label: 'Cell or smart phone' },
  { label: 'Circuit boards' },
  { label: 'Digital Cameras' },
  { label: 'Laptop, Chromebook, or tablet' },
  { label: 'Hair Tools' },
  { label: 'Modem or router' },
];

export const RECYCLING_PRODUCT_ITEMS_NOT_ALLOWED = [
  'External loose batteries (household alkaline or loose lithium)',
  'Airpods or headphones',
  'Smartwatches',
  'Loose hard drives',
  'Keyboards & Mouse',
  'Inkjet Cartr',
  'Light Bulbs (ALL)',
  'Speakers, microphones',
  'Apple Airtags',
  'Toys',
  'Electronic Thermometer',
  'Electric Toothbrushes',
  'Hazardous Waste Pressurized canisters, Paint, Chemicals, Oils, etc.',
  'Medical / Biohazard Waste',
  'Smoke and Carbon monoxide detectors',
  'Radios',
  'Thermostats',
  'Clocks',
  'Kitchen Appliances',
  'Mixed magnetic tapes, CD/DVD, and DLT/LTO, Cassettes',
  'Calculators',
];

export const TABS = {
  WELCOME: 'welcome',
  INVALID: 'invalid',
  PIN: 'pin',
  LOGIN: 'login',
  SELECT_ADDRESS: 'select-address',
  ENTER_NEW_ADDRESS: 'enter-new-address',
  SELECT_SHIPPING_METHOD: 'select-shipping-method',
  SHIPPING_METHOD_GENERATION_ERROR: 'shipping-method-generation-error',
  QR: 'qr',
  COUPON: 'coupon',
  MESSAGE: 'message',
  SHIPPING_REWARD: 'shipping-reward',
  SHIPPING_DETAILS: 'shipping-details',
  EMAIL_FORM: 'email-form',
  RECYCLING_LIST: 'recycling-list',
  DEVICE_BATTERY_WARNING: 'device-battery-warning',
  STICKERS_ADVICE: 'stickers-advice',
  QR_CODE_FORM: 'qr-code-form',
  SERVICE: 'service',
  PAYMENT: 'payment',
  REUSE_BOX: 'reuse-box',
  BATTERY_ALERT: 'battery-alert',
  POST_REGISTRATION_VIRTUAL_BOX: 'post-registration-virtual-box',
};

export const DEFAULT_STEP = {
  label: 'default',
  tabs: [
    TABS.WELCOME,
    TABS.INVALID,
    TABS.MESSAGE,
    TABS.QR_CODE_FORM,
    TABS.SERVICE,
  ],
  header: false,
  stepper: false,
  index: 0,
};

const FINAL_STEP = {
  label: 'final',
  tabs: [
    TABS.SHIPPING_REWARD,
    TABS.SHIPPING_DETAILS,
    TABS.COUPON,
    TABS.QR,
  ],
  header: true,
  stepper: false,
};

export const STEPS = [
  DEFAULT_STEP,
  {
    label: 'Pin',
    tabs: [
      TABS.PIN,
      TABS.RECYCLING_LIST,
      TABS.DEVICE_BATTERY_WARNING,
      TABS.STICKERS_ADVICE,
    ],
    header: true,
    stepper: true,
  },
  {
    label: 'Sign In',
    labelAuthFreeFlow: 'Email',
    tabs: [
      TABS.LOGIN,
      TABS.EMAIL_FORM,
    ],
    header: false,
    stepper: true,
  },
  {
    label: 'Register',
    tabs: [
      TABS.SELECT_ADDRESS,
      TABS.ENTER_NEW_ADDRESS,
    ],
    header: true,
    stepper: true,
  },
  {
    label: 'Ship',
    tabs: [
      TABS.SELECT_SHIPPING_METHOD,
      TABS.SHIPPING_METHOD_GENERATION_ERROR,
    ],
    header: true,
    stepper: true,
  },
  FINAL_STEP,
];

export const STEPS_PAY_ON_SHIP = [
  DEFAULT_STEP,
  {
    label: 'Start',
    tabs: [
      TABS.LOGIN,
      TABS.EMAIL_FORM,
    ],
    header: true,
    stepper: true,
  },
  {
    label: 'Pay',
    tabs: [
      TABS.PAYMENT,
    ],
    header: true,
    stepper: true,
  },
  {
    label: 'Pin',
    tabs: [
      TABS.PIN,
      TABS.RECYCLING_LIST,
      TABS.DEVICE_BATTERY_WARNING,
      TABS.STICKERS_ADVICE,
    ],
    header: true,
    stepper: true,
  },
  {
    label: 'Ship',
    tabs: [
      TABS.SELECT_ADDRESS,
      TABS.ENTER_NEW_ADDRESS,
      TABS.SELECT_SHIPPING_METHOD,
      TABS.SHIPPING_METHOD_GENERATION_ERROR,
    ],
    header: true,
    stepper: true,
  },
  FINAL_STEP,
];

export const STEPS_VIRTUAL_BOX = [
  DEFAULT_STEP,
  {
    label: 'Sign In',
    labelAuthFreeFlow: 'Email',
    tabs: [
      TABS.LOGIN,
      TABS.EMAIL_FORM,
    ],
    header: true,
    stepper: true,
  },
  {
    label: 'Box',
    tabs: [
      TABS.REUSE_BOX,
      TABS.PIN,
    ],
    header: true,
    stepper: true,
  },
  {
    label: 'Add Items',
    tabs: [
      TABS.RECYCLING_LIST,
      TABS.BATTERY_ALERT,
    ],
    header: true,
    stepper: true,
  },
  {
    label: 'Shipping',
    tabs: [
      TABS.SELECT_ADDRESS,
      TABS.ENTER_NEW_ADDRESS,
      TABS.SELECT_SHIPPING_METHOD,
      TABS.SHIPPING_METHOD_GENERATION_ERROR,
    ],
    header: true,
    stepper: true,
  },
  {
    label: 'Success',
    tabs: [
      TABS.POST_REGISTRATION_VIRTUAL_BOX,
    ],
    header: true,
    stepper: true,
  },
];

export const isTechRecyclingProductType = recyclingProductType => (
  recyclingProductType === RECYCLING_PRODUCT_TYPES.TECH
);

export const isTextilRecyclingProductType = recyclingProductType => (
  recyclingProductType === RECYCLING_PRODUCT_TYPES.TEXTIL
);

export const isVirtualBoxRecyclingProductType = recyclingProductType => (
  recyclingProductType === RECYCLING_PRODUCT_TYPES.VIRTUAL
);

export const isBoxRecyclingProductType = recyclingProductType => (
  isTechRecyclingProductType(recyclingProductType)
  || isVirtualBoxRecyclingProductType(recyclingProductType)
);

export const getStepButtonTracker = () => {
  const {
    tbb: {
      stepButton: trackerStepButton,
    },
  } = TRACKER_IDS;

  return trackerStepButton;
};

export const getStepButtonTrackerProps = (
  stepTab,
  recyclingProductType,
  isPayOnShip,
  storeConfig,
  extraProps = {},
) => {
  const trackerStepButton = getStepButtonTracker();

  return {
    [POSTHOG_CAPTURE_ATTRIBUTES.TRACKER_ID]: getTrackerId(trackerStepButton),
    [POSTHOG_CAPTURE_ATTRIBUTES.TBB_STEP]: stepTab,
    [POSTHOG_CAPTURE_ATTRIBUTES.TBB_RECYCLING_PRODUCT_TYPE]: recyclingProductType,
    [POSTHOG_CAPTURE_ATTRIBUTES.TBB_PAY_ON_SHIP]: isPayOnShip,
    [POSTHOG_CAPTURE_ATTRIBUTES.PARTNER_ID]: storeConfig.id,
    [POSTHOG_CAPTURE_ATTRIBUTES.PARTNER_NAME]: storeConfig.title,
    ...extraProps,
  };
};

export const TBB_PAYMENT_CONFIG_ITEMS = {
  recycling: 'recycling',
  sweepstakes: 'sweepstakes',
  exclusive_rewards: 'exclusive_rewards',
  gift_cards: 'gift_cards',
  unlock_rewards: 'unlock_rewards',
  deals_shelves: 'deals_shelves',
};

export const TBB_PAYMENT_CONFIG_ITEMS_CONTENT = {
  [TBB_PAYMENT_CONFIG_ITEMS.recycling]: [
    {
      title: (
        <>
          Recycle
          <br />
          up to
        </>
      ),
      description: '15 lbs',
      getIcon: (size = ICON_CIRCLE_SIZE.SMALL) => (
        <IconCircled
          icon={(
            <RecycleSVG
              color="var(--trashie-ui-faded-black-100)"
            />
          )}
          backgroundColor="var(--japan-color-hard-mint)"
          size={size}
        />
      ),
    },
    {
      title: (
        <>
          Return
          <br />
          shipping
          <br />
          included via
        </>
      ),
      description: 'UPS',
      getIcon: (size = ICON_CIRCLE_SIZE.SMALL) => (
        <IconCircled
          icon={(
            <img
              src={UPSSvg}
              alt="ups"
            />
          )}
          backgroundColor="var(--trashie-primary-berlin-yellow)"
          size={size}
        />
      ),
    },
  ],
};

export const TBB_PARTNER_TAG = '%partner%';
export const TBB_TC_ICON = '%TC%';
export const TBB_CREDIT_AMOUNT_TAG = '%creditAmt%';

export function filterOneRewardPerStore(rewards) {
  const filteredRewards = [];
  const uniqueStores = new Set();

  rewards.forEach((r) => {
    if (!uniqueStores.has(r.storeId)) {
      uniqueStores.add(r.storeId);
      filteredRewards.push(r);
    }
  });

  return filteredRewards;
}

export const replaceJSX = (content, find, replace) => content.split(find)
  .flatMap((item) => [item, replace]).slice(0, -1);

export const insertTCIcon = (content, size = MINIMUM_TC_ICON_SIZE, color = 'var(--membership-lime)') => {
  const parts = content.split(TBB_TC_ICON);
  return (
    <span style={{ display: 'flex', alignItems: 'center', gap: '0.25em' }}>
      {parts.map((part, index) => (
        index < parts.length - 1 ? (
          <>
            {part}
            <TCCoinSvg width={size} height={size} color={color} />
          </>
        ) : part
      ))}
    </span>
  );
};

export const getPerksCardIcon = (key) => {
  switch (key) {
    case 'recycling':
      return <img src={TbbPink} alt="tbb-pink" height={36} width={36} />;
    case 'shipping':
      return <img src={UPSSvg} alt="ups" height={36} width={36} />;
    case 'Earn':
      return <img src={TcIcon} alt="coin" height={36} width={36} />;
    case 'gift_cards':
      return <img src={GiftCardSvg} alt="gift card" height={36} width={36} />;
    default:
      return null;
  }
};
